import merge from "lodash.merge";
import { useFieldArray, useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { LoanDetailsController } from "services/loanDetails/controller";
import { useAccordionWizard } from "stories";
import { AccordionForm } from "stories/components/accordionForm";
import { useToast } from "utils/customHooks/useToast";
import CompanyItem from "./companyItem";

const loanDetailsController = LoanDetailsController();

export const teamMemberModel = {
  description: "",
  name: "",
  position: "",
};

const getProjectMemberModel = () => ({
  company_name: "",
  project_role: "",
  website: "",
  members: [{ ...teamMemberModel }],
});
export const LoanDetailsMembersQueryKey = "loan-details-members";
const LoanDetailsMembers = () => {
  const params = useParams();
  const form = useForm({
    defaultValues: {
      projectMembers: [getProjectMemberModel()],
    },
  });
  const {
    fields: projectMembers,
    append: addProjectMember,
    remove: deleteProjectMember,
  } = useFieldArray({
    control: form.control,
    name: "projectMembers",
  });
  const { showToast } = useToast();
  const { next } = useAccordionWizard();
  const queryKey = [LoanDetailsMembersQueryKey, { id: params.id }];
  const queryClient = useQueryClient();

  const { isLoading: fetchLoading } = useQuery({
    queryKey,
    queryFn: loanDetailsController.getAdditionalTeamMembers.bind(
      null,
      params.id
    ),
    onSuccess: (data) => {
      form.reset(
        merge(form.getValues(), {
          projectMembers: data,
        })
      );
    },
  });

  const handleMemberSubmit = (values) => {
    const body = { members: values.projectMembers };
    body.id = params.id;
    return loanDetailsController.updateAdditionalTeamMembers(body);
  };

  const { mutate, isLoading: postLoading } = useMutation(handleMemberSubmit, {
    onSuccess: () => {
      showToast("Additional Members Updated!", "success");
      next();
      queryClient.invalidateQueries(queryKey);
    },
  });

  const handleAddProjectMember = () => {
    addProjectMember(getProjectMemberModel());
  };
  return (
    <AccordionForm
      accordionKey="additional-members"
      accordionTitle="Additional Project Team Members"
      form={form}
      isPostLoading={postLoading}
      isPreLoading={fetchLoading}
      onSubmit={mutate}
    >
      <div className={"px-3"}>
        {projectMembers.map((item, index) => {
          return (
            <CompanyItem
              key={item.id}
              index={index}
              onDelete={() => deleteProjectMember(index)}
            />
          );
        })}
        <div
          className={"fw-bold text-primary my-3 d-inline-block"}
          role={"button"}
          onClick={handleAddProjectMember}
        >
          + Add Project Team Members
        </div>
      </div>
    </AccordionForm>
  );
};

export default LoanDetailsMembers;
